import localForage from 'localforage';

export default class StorageManager {
  initStorage() {
    // config LocalForage
    localForage.config({
      name: 'ByteArk Account',
    });

    localForage.getItem('teams').then((value) => {
      if (!value) {
        localForage.setItem('teams', {});
      }
    });
  }

  setCredential(credential, namespace) {
    const now = new Date();
    credential.created_at = now.getTime();
    credential.namespace = namespace;

    namespace = namespace.trim();

    // store credential in localStorage
    return localForage.getItem('teams').then((teams) => {
      if (teams[namespace]) {
        // update team's credential
        teams[namespace].credential = credential;
      } else {
        teams[namespace] = {
          credential: credential,
          lang: 'th',
          team: { },
        };
      }

      localForage.setItem('teams', teams);

      return teams[namespace];
    });
  }

  getCredential(namespace) {
    return localForage.getItem('teams').then((teams) => {
      if (teams && teams[namespace]) {
        return teams[namespace].credential;
      } else {
        return null;
      }
    });
  }

  removeCredential(namespace) {
    // remove credential
    return localForage.getItem('teams').then((teams) => {
      if (teams && teams[namespace]) {
        delete teams[namespace];
        return localForage.setItem('teams', teams);
      }

      return;
    });
  }

  setTeam(team) {
    return localForage.getItem('teams').then((teams) => {
      if (teams && teams[team.namespace]) {
        teams[team.namespace].team = {
          team_id: team.id,
          name: team.name,
          namespace: team.namespace,
        };

        return localForage.setItem('teams', teams);
      }
    });
  }

  getTeam(namespace) {
    return localForage.getItem('teams').then((teams) => {
      return teams[namespace];
    });
  }

  getTeams() {
    return localForage.getItem('teams').then((teams) => {
      if (teams) {
        return Object.values(teams).map((data) => {
          return data.team;
        });
      } else {
        return [];
      }
    });
  }

  setLang(lang, namespace) {
    return localForage.getItem('teams').then((teams) => {
      if (teams && teams[namespace]) {
        teams[namespace].lang = lang;

        return localForage.setItem('teams', teams);
      }

      return;
    });
  }

  getLang(namespace) {
    return localForage.getItem('teams').then((teams) => {
      if (teams && teams[namespace]) {
        return teams[namespace].lang;
      }

      // return default lang
      return 'th';
    });
  }

}



// WEBPACK FOOTER //
// ./src/managers/StorageManager.js